import { DateTimeFormat } from '@billy/design-system'
import { TFunction } from 'i18next'

import { AuditTrailAccountTable } from '../../../AuditTrail/types/AuditTrail'

interface BuildFlatAuditTrailTableProps {
  data: AuditTrailAccountTable[]
  locale?: string
  t: TFunction
}

export const buildFlatAuditTrailTable = ({ data, locale, t }: BuildFlatAuditTrailTableProps) =>
  data.flatMap((group) => {
    const { tableName, total, mainData, type } = group
    const isAccount = type === 'account'

    const header = [
      '#',
      t('audit_trail.table.header.date'),
      t('audit_trail.table.header.voucher'),
      t('audit_trail.table.header.description'),
      ...(isAccount ? [t('audit_trail.table.header.net_amount'), t('audit_trail.table.header.rate')] : []),
      t('audit_trail.table.header.amount'),
      t('audit_trail.table.header.balance'),
    ]

    const rows = mainData.map(({ transaction, date, voucher, description, netAmount, rate, amount, balance }) => [
      transaction ?? '',
      date ? DateTimeFormat.getFormattedDate(date, locale) : '',
      voucher ?? '',
      description ?? '',
      ...(isAccount ? [netAmount ?? '', rate ?? ''] : []),
      amount ?? '',
      balance ?? '',
    ])

    /* Audit trail table has a set amount of columns, so it is safe to go with '', and in this footer row we want total to be aligned with the two last columns */
    const totalRow = ['', '', '', '', '', '', `${t('audit_trail.table.footer.total')}:`, total]

    return [[tableName], header, ...rows, totalRow, []]
  })
